import { PatientInsuranceUpdateBase } from "./PatientInsuranceUpdateBase";
import { ParsedInsuranceData } from "./ParsedInsuranceData";

export interface PatientInsuranceUpload extends PatientInsuranceUpdateBase {
    patStoreid: number,
    imageURLs: string[],
    uploaded: Date,
    aiParsedDate?: Date,
    aiParseData?: string,
    aiParseVersion?: number,
    aiParseAttemptCount?: number,
    aiParsedDataUsed?: boolean,
    aiParsedDataEdited?: boolean,
}

export class PatientInsuranceUpload {

    constructor(obj?:PatientInsuranceUpload){
        if(obj) Object.assign(this, obj);
    }

    hasAIParsedData(): boolean {
        return !!(this as any).aiParseData && !!(this as any).aiParsedDate;
    }

    getParsedData(): ParsedInsuranceData | null {
        if (!this.hasAIParsedData() || !(this as any).aiParseData) {
            return null;
        }
        try {
            return JSON.parse((this as any).aiParseData) as ParsedInsuranceData;
        } catch (e) {
            console.error('Failed to parse AI insurance data:', e);
            return null;
        }
    }
}
